var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6667 3.41602V7.79102M23.3333 3.41602V7.79102M5.10417 13.7556H29.8958M30.625 12.8952V25.291C30.625 29.666 28.4375 32.5827 23.3333 32.5827H11.6667C6.5625 32.5827 4.375 29.666 4.375 25.291V12.8952C4.375 8.52018 6.5625 5.60352 11.6667 5.60352H23.3333C28.4375 5.60352 30.625 8.52018 30.625 12.8952Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.8888 20.4785H22.902M22.8888 24.8535H22.902M17.493 20.4785H17.5076M17.493 24.8535H17.5076M12.0957 20.4785H12.1103M12.0957 24.8535H12.1103",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c69dc5abbfe28a6b85bc447baf7743d2.svg";
export { ForwardRef as ReactComponent };